import React from 'react';
import { Link } from 'react-router-dom';
const experts = [{
  id: 1,
  name: 'Sarah Johnson',
  title: 'Forex Trading Expert',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=988&q=80',
  description: 'Former Wall Street trader with 15+ years of experience',
  slug: 'sarah-johnson'
}, {
  id: 2,
  name: 'Michael Chen',
  title: 'Technical Analysis Specialist',
  image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80',
  description: 'Award-winning analyst and trading strategy developer',
  slug: 'michael-chen'
}, {
  id: 3,
  name: 'Elena Rodriguez',
  title: 'Risk Management Expert',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1061&q=80',
  description: 'Specializing in sustainable trading strategies and psychology',
  slug: 'elena-rodriguez'
}, {
  id: 4,
  name: 'David Park',
  title: 'Cryptocurrency Trading Expert',
  image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80',
  description: 'Pioneer in digital asset trading and blockchain technology',
  slug: 'david-park'
}];
export function ExpertsSection() {
  return <section className="py-20 bg-black" data-id="element-41">
      <div className="container mx-auto px-4" data-id="element-42">
        <div className="text-center mb-16" data-id="element-43">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-44">
            Learn from Top Trading Experts
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-45">
            Our instructors are industry leaders who share their expertise and
            insider knowledge to help you succeed.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-46">
          {experts.map(expert => <div key={expert.id} className="group" data-id="element-47">
              <div className="relative overflow-hidden mb-4" data-id="element-48">
                <img src={expert.image} alt={expert.name} className="w-full aspect-[3/4] object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-49" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4" data-id="element-50">
                  <Link to={`/classes/expert/${expert.slug}`} className="bg-red-600 text-white w-full py-2 rounded font-medium hover:bg-red-700 transition-colors text-center" data-id="element-51">
                    View Class
                  </Link>
                </div>
              </div>
              <h3 className="font-bold text-xl" data-id="element-52">{expert.name}</h3>
              <p className="text-gray-400" data-id="element-53">{expert.title}</p>
              <p className="mt-2 text-sm text-gray-300" data-id="element-54">{expert.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}